import React from 'react';

import RowBase from 'antd/lib/row';

const Row = ({ ...props }) => <RowBase {...props} />

export default Row;